module.exports = __webpack_public_path__ + "static/img/Jack-Wighton.77076ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Wighton.jpg
// module id = jnE5
// module chunks = 0